import React from 'react'
import PropTypes from 'prop-types'

import { Box, FormControlLabel, Grid, Switch, Typography } from '@material-ui/core'
export class Card extends React.Component {
  renderExample(idx) {
    if (idx >= this.props.examples.length) {
      return (
        <Typography
          color="textSecondary"
          variant="body2"
        >
          &nbsp;
        </Typography>
      )
    }
    return (
      <Typography
        color="textSecondary"
        variant="body2"
      >
        {this.props.examples[idx]}
      </Typography>
    )
  }

  render() {
    return (
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
      >
        <FormControlLabel
          disabled={this.props.required}
          control={
            <Switch
              color="primary"
              disableFocusRipple={false}
              checked={this.props.selected}
              onChange={this.props.onToggle}
              name={this.props.fieldName}
            />
          }
          label={
            <Box>
              <Box display="flex">
                <Typography>{this.props.label}</Typography>
                {this.props.required && <Typography>&#65121;</Typography>}
              </Box>
              {this.renderExample(0)}
              {this.renderExample(1)}
            </Box>
          }
        />
      </Grid>
    )
  }
}

Card.defaultProps = {
  examples: [],
  selected: false,
  required: false,
}

Card.propTypes = {
  required: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  examples: PropTypes.array,
  onToggle: PropTypes.func,
  fieldName: PropTypes.string,
}

export default Card
